// For Investing and English Projects
export const SECTION_TYPES_WITH_PROBLEMS = ['reading_project', 'question_set'];
export const SECTION_TYPES_WITH_WHITEBOARD = ['concept', 'activity'];
export const SECTION_TYPES_WITH_RIGHT_PANEL = [
  'activity',
  ...SECTION_TYPES_WITH_PROBLEMS,
];
export const PUBLISHABLE_SECTION_TYPES = ['concept', 'activity', 'writing_project'];
export const PUBLISHABLE_PROJECT_TYPES = ['english_writing'];
